import { render, staticRenderFns } from "./NewRequestView.vue?vue&type=template&id=7f37de0d&scoped=true"
import script from "./NewRequestView.vue?vue&type=script&lang=js"
export * from "./NewRequestView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/abiturient.css?vue&type=style&index=0&id=7f37de0d&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/abiturient/NewRequestView.css?vue&type=style&index=1&id=7f37de0d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f37de0d",
  null
  
)

export default component.exports